import { render, staticRenderFns } from "./previewPhoto.vue?vue&type=template&id=7309a6e2&"
import script from "./previewPhoto.vue?vue&type=script&lang=ts&"
export * from "./previewPhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports